import { createContext, useCallback, useState, useEffect } from "react";
import API_URL from "../config/apiConfig";
import { io } from "socket.io-client";
import { deleteRestaurantMenu, getRestaurantMenu } from "../api/menu";

export const FoodServiceContext = createContext();

export const FoodServiceProvider = ({ restaurantId, children }) => {
  const [restaurantData, setRestaurantData] = useState(null);
  const [restaurantSettings, setRestaurantSettings] = useState(null);
  const [menuData] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [menuLoading, setMenuLoading] = useState(false);
  const [menuError, setMenuError] = useState(null);

  const [orders, setOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(true);
  const [ordersError, setOrdersError] = useState(null);
  const [newOrder, setHasNewOrder] = useState(false);


  
  // ===== fetch restaurant =====
  useEffect(() => {
    // console.log("Provider render");

    if (!restaurantId) return;

    const fetchRestaurant = async () => {
      setLoading(true);
      setError(null);

      try {
        const stored = localStorage.getItem(`restaurantData_${restaurantId}`);

        if (stored) {
          const parsed = JSON.parse(stored);
          setRestaurantData(parsed);
          setRestaurantSettings(parsed.restaurantSettings || null);
          setLoading(false);
          return;
        }

        const res = await fetch(`${API_URL}/api/restaurants/${restaurantId}`);
        if (!res.ok) throw new Error("مشکل در دریافت داده رستوران");

        const data = await res.json();

        setRestaurantData(data);
        setRestaurantSettings(data.restaurantSettings || null);

        localStorage.setItem(
          `restaurantData_${restaurantId}`,
          JSON.stringify(data)
        );
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRestaurant();
  }, [restaurantId]);

  useEffect(() => {
    // console.log("restaurantData changed:", restaurantData);
  }, [restaurantData]);

  // ===== fetch menu =====
  const [menuDataMap, setMenuDataMap] = useState({});

  const fetchMenu = useCallback(async (menuId) => {
    if (!menuId) return;

    setMenuLoading(true);
    setMenuDataMap((prev) => ({ ...prev, [menuId]: null }));
    setMenuError(null);

    try {
      const data = await getRestaurantMenu(menuId);
      setMenuDataMap((prev) => ({ ...prev, [menuId]: data }));
    } catch (err) {
      console.error(err);
      setMenuError(err.response?.data?.msg || err.message);
    } finally {
      setMenuLoading(false);
    }
  }, []);






  ///////////////////

 const fetchOrders = useCallback(async (signal) => {
  if (!restaurantId) {
    setOrders([]);
    setOrdersLoading(false);
    return;
  }

  setOrdersLoading(true);
  setOrdersError(null);
  try {
    const res = await fetch(`${API_URL}/api/orders/${restaurantId}`, {
      signal,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    if (!res.ok) throw new Error("خطا در دریافت سفارش‌ها");
    const data = await res.json();
    if (!signal?.aborted) setOrders(Array.isArray(data) ? data : []);
  } catch (err) {
    if (err.name !== "AbortError") {
      console.error(err);
      setOrdersError(err.message);
    }
  } finally {
    if (!signal?.aborted) setOrdersLoading(false);
  }
}, [restaurantId]);

 useEffect(() => {
  const controller = new AbortController();

  fetchOrders(controller.signal);

  // 2️⃣ اتصال socket
  const socket = io(API_URL);
  socket.emit("joinRoom", restaurantId);

  socket.on("newOrder", (newIncomingOrder) => {
    setOrders(prev => [newIncomingOrder, ...prev]);
    setHasNewOrder(true);
  });

  socket.on("updateOrder", (updatedOrder) => {
    setOrders(prev =>
      prev.map(o => (o._id === updatedOrder._id ? updatedOrder : o))
    );
  });

  return () => {
    controller.abort();
    socket.disconnect();
  };
}, [fetchOrders, restaurantId]);

  /////////////////////////////////////////







  // ===== delete menu =====
  const deleteMenu = async (menuId) => {
    try {
      return await deleteRestaurantMenu(menuId);
    } catch (err) {
      console.error("خطا در deleteMenu:", err);
      throw err; // می‌فرستیم که کامپوننت متوجه شود
    }
  };


  return (
    <FoodServiceContext.Provider
      value={{
        restaurantData,
        restaurantSettings,
        menuData,
        loading,
        error,
        menuDataMap,
        menuLoading,

        menuError,
        orders,
        ordersLoading,
        ordersError,
        newOrder,
        setOrders,
        fetchOrders,
        setHasNewOrder,

        setRestaurantData,   // ← اضافه کن
        fetchMenu,
        deleteMenu,
      }}
    >
      {children}
    </FoodServiceContext.Provider>
  );
};
